import { Box, Grid, Typography } from '@mui/material';
import CustomButton from 'lib/designSystem/Button';
import { formatMoney } from 'lib/functions/utils';
import React from 'react';

interface ResellPreview {
  rate: number;
  rateCost: number;
  operationCostFixed: number;
  amount: number;
}

const ResellSummary = ({
  resells,
  setOpenDocumentSelector,
}: {
  resells: ResellPreview[];
  setOpenDocumentSelector: (open: boolean) => void;
}) => {
  const avgRate =
    resells.reduce(
      (acc: number, resell: ResellPreview) => acc + Number(resell.rate),
      0,
    ) / resells.length;
  const rateCost = resells.reduce(
    (acc: number, resell: ResellPreview) => acc + Number(resell.rateCost),
    0,
  );
  const operationCostFixed = resells.reduce(
    (acc: number, resell: ResellPreview) =>
      acc + Number(resell.operationCostFixed),
    0,
  );
  const operationCostFixedWithIVA = operationCostFixed * 1.19;
  const totalAmount = resells.reduce(
    (acc: number, resell: ResellPreview) => acc + Number(resell.amount || 0),
    0,
  );

  return (
    <Grid container alignItems="center" spacing={2}>
      <Grid item xs={10}>
        <Grid container spacing={3}>
          <Grid item>
            <Box textAlign="center">
              <Typography variant="body2" color="text.secondary">
                Monto nómina
              </Typography>
              <Typography variant="h6" fontWeight="bold">
                {formatMoney(totalAmount)}
              </Typography>
            </Box>
          </Grid>
          <Grid item>
            <Box textAlign="center">
              <Typography variant="body2" color="text.secondary">
                Facturas
              </Typography>
              <Typography variant="h6" fontWeight="bold">
                {resells.length}
              </Typography>
            </Box>
          </Grid>
          <Grid item>
            <Box textAlign="center">
              <Typography variant="body2" color="text.secondary">
                Tasa promedio
              </Typography>
              <Typography variant="h6" fontWeight="bold">
                {(avgRate || 0).toFixed(2)}%
              </Typography>
            </Box>
          </Grid>
          <Grid item>
            <Box textAlign="center">
              <Typography variant="body2" color="text.secondary">
                Diferencia de precio
              </Typography>
              <Typography variant="h6" fontWeight="bold">
                {formatMoney(rateCost)}
              </Typography>
            </Box>
          </Grid>
          <Grid item>
            <Box textAlign="center">
              <Typography variant="body2" color="text.secondary">
                Comisión + IVA
              </Typography>
              <Typography variant="h6" fontWeight="bold">
                {formatMoney(operationCostFixedWithIVA)}
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={2} textAlign="right">
        <CustomButton
          onClick={() => setOpenDocumentSelector(true)}
          color="primary"
          variant="contained"
        >
          Agregar facturas
        </CustomButton>
      </Grid>
    </Grid>
  );
};

export default ResellSummary;
